import React from 'react';
import { formatAmount, formatMoney } from '../../../../utils/utils';
import { momentParseDate, momentParseDateWithDayOfWeek } from '../../../../helpers';
import { Link } from 'react-router-dom';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

type Props = {
    data: any[];
    progressPending?: boolean;
    totalRows: number;
    filter: any;
    setFilter: (filter: any) => void;
    ufValue?: number
};

const HolidaysDataTable = ({ 
    data, 
    progressPending, 
    totalRows,
    filter,
    setFilter,
    ufValue,
}: Props) => {
    const columns = [
        {
            name: 'Fecha',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: any, index: any, column: any) => (                                   
                <span className="">
                    {momentParseDateWithDayOfWeek(row.this_year_date)}
                </span>
            )
        },
        {
            name: 'Feriado',
            selector: (row: any) => row.bank,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.name}</span>
            )
        },
        {
            name: 'Evento',
            selector: (row: any) => row.bank,
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.event?.event_type?.name}</span>
            )
        },
        {
            name: 'Valor UF',
            sortable: false,
            cell: (row: any, index: any, column: any) => (
                <span className="">{ufValue ? formatAmount(ufValue) : ''} CLP</span>
            )
        },
        // {
        //     name: 'Viáticos',
        //     selector: (row: any) => row?.program_date,
        //     sortable: false,
        //     sortField: 'program_date',
        //     minWidth: '120px',
        //     cell: (row: any, index: any, column: any) => (
        //         <span className="">
        //             {formatMoney(row.event?.travel_expense?.budget)}
        //         </span>
        //     )
        // },

    ]
    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={data}
                progressPending={progressPending} 
                paginationTotalRows={totalRows}                
                filter={filter} 
                setFilter={setFilter}         
                isMobileStacked={true}   
            />
        </div>
    )
}

export default HolidaysDataTable
